function getTime() {
  return new window.Date().getTime();
}

export function setItem(key, value, expiration) {
  let item = {
    data: value,
  };
  if (expiration !== undefined) {
    item = Object.assign(
      item,
      { expiration: getTime() + expiration },
    );
  }
  window.localStorage.setItem(key, JSON.stringify(item));
  return item;
}

export function removeItem(key) {
  return window.localStorage.removeItem(key);
}

export function getItem(key) {
  const data = JSON.parse(window.localStorage.getItem(key));
  if (data !== null) {
    if (data.expiration !== undefined) {
      if (getTime() < data.expiration) {
        return data.data;
      }
      removeItem(key);
      return null;
    }
    return data.data;
  }
  return null;
}

export function clear() {
  return window.localStorage.clear();
}



// WEBPACK FOOTER //
// ./src/utils/storage.js